import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export default function ScrollAnimations(){
  const {pathname}=useLocation();
  useEffect(()=>{
    const selectors='.section-head,.center-head,.split,.service-card,.project-card,.tech-card,.why-grid article,.process-row>div,.quote-card,.values-grid article,.jobs article,.form-card,.contact-cards>div';
    const nodes=[...document.querySelectorAll(selectors)];
    nodes.forEach((node,index)=>{
      node.classList.add('reveal');
      node.style.setProperty('--reveal-delay',`${Math.min(index%8,5)*70}ms`);
    });
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting){entry.target.classList.add('revealed');observer.unobserve(entry.target)}
    }),{threshold:.12,rootMargin:'0px 0px -35px'});
    nodes.forEach(node=>observer.observe(node));
    return ()=>observer.disconnect();
  },[pathname]);
  return null;
}
